"use strict";

exports.__esModule = true;
exports.isUserInputClassification = void 0;
var isUserInputClassification = exports.isUserInputClassification = function isUserInputClassification(source) {
  return source === "user-input";
};